var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#0A1E60","fillRule":"evenodd","d":"M21.061.168c2.473.012 12.386.107 15.118.854 1.727.47 3.086 1.858 3.548 3.62.787 2.998.836 9.054.838 9.785v.145c-.002.73-.05 6.786-.838 9.784-.462 1.762-1.821 3.15-3.548 3.621-1.143.312-3.54.51-6.126.637l-.677.03-.682.029c-3.414.133-6.829.155-7.872.159h-.645c-.905-.003-3.59-.02-6.513-.112l-.677-.022c-3.29-.115-6.727-.327-8.168-.721-1.726-.471-3.086-1.859-3.548-3.62-.736-2.804-.826-8.278-.837-9.577v-.562c.01-1.299.101-6.773.837-9.576.462-1.762 1.822-3.15 3.548-3.62C6.011.696 8.571.494 11.283.369l.68-.03c.341-.014.683-.027 1.024-.039l.677-.022c2.698-.084 5.194-.105 6.273-.11ZM16.2 8.766v12.9l11.467-6.45L16.2 8.766Z"}));
}

Youtube.defaultProps = {"viewBox":"0 0 41 29"};

module.exports = Youtube;

Youtube.default = Youtube;
